import { Routes, Route, Navigate } from "react-router-dom";
import React, { Suspense, Fragment } from "react";
import LoadingScreen from "./components/ui/LoadingScreen";

const Home = React.lazy(() => import("./pages/home"));
const Education = React.lazy(() => import("./pages/education"));
const Skills = React.lazy(() => import("./pages/skills"));
const Experience = React.lazy(() => import("./pages/experience"));
const Projects = React.lazy(() => import("./pages/projects"));
const About = React.lazy(() => import("./pages/about"));

function App() {
  return (
    <Fragment>
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Home />} />
          <Route path="/education" element={<Education />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Suspense>
    </Fragment>
  );
}

export default App;
